import React, { useState } from 'react';
import { Button, Menu, MenuItem, Box, useTheme, useMediaQuery } from '@mui/material';
import { Language as LanguageIcon, ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';

// We can define the language names here or pass them in as a prop
const languageMap = {
    en: 'English',
    zh: '中文',     // Mandarin
    hi: 'हिन्दी',   // Hindi
    es: 'Español',  // Spanish
    ar: 'العربية'   // Arabic
};

const LanguageSwitcher = ({ currentLanguage, onLanguageChange, availableLangs = [] }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const open = Boolean(anchorEl);

    if (availableLangs.length <= 1) {
        return null; // Don't show if there's only one language option
    }

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleLanguageSelect = (langCode) => {
        onLanguageChange(langCode); // Call the function passed from the parent
        handleClose();
    };
    
    // Desktop view: Simple buttons
    if (isDesktop) {
        return (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <LanguageIcon sx={{ color: 'text.secondary', mr: 0.5 }} />
                {availableLangs.map((code) => (
                    <Button
                        key={code}
                        size="small"
                        variant={currentLanguage === code ? 'contained' : 'text'}
                        onClick={() => handleLanguageSelect(code)}
                    >
                        {languageMap[code]}
                    </Button>
                ))}
            </Box>
        );
    }
    
    // Mobile view: Compact dropdown menu
    return (
        <Box>
            <Button
                id="language-button"
                aria-controls={open ? 'language-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant="outlined"
                size="small"
                sx={{ textTransform: 'none' }}
                startIcon={<LanguageIcon />}
                endIcon={<ArrowDropDownIcon />}
            >
                {languageMap[currentLanguage]}
            </Button>
            <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'language-button' }}
            >
                {availableLangs.map((code) => (
                    <MenuItem
                        key={code}
                        selected={code === currentLanguage}
                        onClick={() => handleLanguageSelect(code)}
                    >
                        {languageMap[code]}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default LanguageSwitcher;